const EarlyGothicEra = {
  id: '14',
  name: 'Late Gothic Era'
};

export default EarlyGothicEra;
